/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiSnoozeConfig } from './InternalApiSnoozeConfig';
import {
    InternalApiSnoozeConfigFromJSON,
    InternalApiSnoozeConfigFromJSONTyped,
    InternalApiSnoozeConfigToJSON,
    InternalApiSnoozeConfigToJSONTyped,
} from './InternalApiSnoozeConfig';

/**
 * 
 * @export
 * @interface InternalApiSnoozeEvent
 */
export interface InternalApiSnoozeEvent {
    /**
     * 
     * @type {InternalApiSnoozeConfig}
     * @memberof InternalApiSnoozeEvent
     */
    snoozeConfig: InternalApiSnoozeConfig;
    /**
     * 
     * @type {InternalApiSnoozeEventEventTypeEnum}
     * @memberof InternalApiSnoozeEvent
     */
    eventType: InternalApiSnoozeEventEventTypeEnum;
}

/**
* @export
* @enum {string}
*/
export enum InternalApiSnoozeEventEventTypeEnum {
    CREATE = 'CREATE',
    UPDATE = 'UPDATE',
    DELETE = 'DELETE'
}


/**
 * Check if a given object implements the InternalApiSnoozeEvent interface.
 */
export function instanceOfInternalApiSnoozeEvent(value: object): value is InternalApiSnoozeEvent {
    if (!('snoozeConfig' in value) || value['snoozeConfig'] === undefined) return false;
    if (!('eventType' in value) || value['eventType'] === undefined) return false;
    return true;
}

export function InternalApiSnoozeEventFromJSON(json: any): InternalApiSnoozeEvent {
    return InternalApiSnoozeEventFromJSONTyped(json, false);
}

export function InternalApiSnoozeEventFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiSnoozeEvent {
    if (json == null) {
        return json;
    }
    return {
        
        'snoozeConfig': InternalApiSnoozeConfigFromJSON(json['snoozeConfig']),
        'eventType': json['eventType'],
    };
}

export function InternalApiSnoozeEventToJSON(json: any): InternalApiSnoozeEvent {
    return InternalApiSnoozeEventToJSONTyped(json, false);
}

export function InternalApiSnoozeEventToJSONTyped(value?: InternalApiSnoozeEvent | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'snoozeConfig': InternalApiSnoozeConfigToJSON(value['snoozeConfig']),
        'eventType': value['eventType'],
    };
}

